export enum LiveClassEventType {
    USER = 'user',
    SYSTEM = 'system',
}



// WEBPACK FOOTER //
// ./ts/app/shared/types/LiveClassEventType.ts